module.exports = __webpack_public_path__ + "static/openproject-0e3b23360f3f7fd21180781f77f37808.svg";